import { Cache, getHash } from './cache';
import { IDbCache } from '../models/cache';
import { ICacheClearArgs } from '../models/cache-clear-args';
import { ICacheReadArgs } from '../models/cache-read-args';
import { ICachedValue } from '../models/cached-value';
import { IDbCacheDAO } from '../models/db-cache-dao';
import { ISillyLogger } from '../models/silly-logger';

export class DbCache extends Cache implements IDbCache {
  protected cacheName = 'Db';

  constructor(
    private args: {
      cachedValueDAO: IDbCacheDAO;
      logger?: ISillyLogger;
    },
  ) {
    super(args.logger);
  }

  public async read<T>(args: ICacheReadArgs<T>): Promise<T> {
    if (process.env.DISABLE_DB_CACHE === 'true') {
      return args.retrieve();
    }
    const hash = getHash(args.bucket, args.id);
    const cached = await this.args.cachedValueDAO.findByHash(hash);
    return this.handleCachedRead(cached, args);
  }

  public async clear(args?: ICacheClearArgs) {
    if (process.env.DISABLE_DB_CACHE === 'true') {
      return;
    }
    if (!args) {
      await this.args.cachedValueDAO.removeAll();
    } else {
      const hash = getHash(args.bucket, args.id);
      await this.args.cachedValueDAO.removeByHash(hash);
    }
  }

  public async readByBucket<T>(bucket: string): Promise<{ [id: string]: T }> {
    if (process.env.DISABLE_DB_CACHE === 'true') {
      return {};
    }
    const cachedValues = await this.args.cachedValueDAO.findByBucket(bucket);
    return cachedValues.reduce((acc, cached) => {
      const id = cached.hash.split(':')[1];
      acc[id] = cached.value;
      return acc;
    }, {});
  }

  public async clearByBucket(bucket: string) {
    if (process.env.DISABLE_DB_CACHE === 'true') {
      return;
    }
    await this.args.cachedValueDAO.removeByBucket(bucket);
  }

  protected saveToCache<T>(cached: ICachedValue) {
    // Write to the cache in the background without waiting for the result. Gotta go fast!
    this.args.cachedValueDAO.upsert(cached).then();
  }
}
